var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("i", { staticClass: "icon-calendar fa fa-calendar" }),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      class: _vm.inputClass,
      attrs: {
        type: "text",
        name: _vm.inputName,
        "data-wow-attr": _vm.inputDataWowAttr,
        placeholder: _vm.inputPlaceholder,
        autocomplete: _vm.inputAutocomplete
      }
    }),
    _vm._v(" "),
    _vm.hasValue
      ? _c("i", {
          ref: "clearBtn",
          staticClass: "btn-clear fa fa-times uk-position-center-right",
          attrs: { "data-wow-attr": "clearPeriodRangeIcon" },
          on: {
            click: function(e) {
              return _vm.clearValue(e)
            }
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }